<template>
    <div>
        <div class="drop_custom" v-click-outside="()=> isOpen = false">
            <div class="label_name">
                <span>{{ label }}</span>
                <!-- <ModalPresetMetal v-if="type == 'metal'"/> -->
                <!-- <ModalPresetDiamondShape v-if="type == 'shape'" /> -->
                <!-- <ModalPresetDiamondCarat v-if="type == 'weight'" /> -->
                <ModalPresetDiamondQuality v-if="type == 'cen_stone_quality'"/>

                <span v-if="$country.is_india && type === 'size'">&nbsp;(IN)</span>
                <span v-if="!$country.is_india && type === 'size'">&nbsp;(US)</span>
                <NuxtLink :to="localePath('/how-to-find-ring-size')" v-if="['size', 'her_size', 'his_size'].includes(type)">
                    <SvgHeaderSvg class="ms-2" :type="'ask'" />
                </NuxtLink>
            </div>
            
            <div key="1" class="selected_label d-flex align-items-center" :class="{focused: isOpen, 'invalid': validation }" @click="isOpen = !isOpen" >
                <div class="d-flex align-items-center">
                    <SvgMetalSvg v-if="currentActive && ['metal'].includes(type)" class="me-2" :type="currentActive.icon" />
                    <SvgShapeSvg v-if=" currentActive && ['shape'].includes(type)" class="me-2" :type="currentActive.icon" />
                    <label v-if="currentActive">{{ currentActive.label }}</label>
                    <label v-if="!currentActive">please select</label>
                </div>
                <SvgHeaderSvg v-if="!isOpen" :type="'down'" />
                <SvgHeaderSvg v-else :type="'up'" />
            </div>
            <div  class="drop_block" v-show="isOpen">
                <ul class="drop_options">
                    <li 
                        v-for="item in props.option" :key="item.value"
                        @click="addActive(item.value)"
                        :class="{'active': item.selected === 1, 'disabled': item.visibility === 0}"
                    >
                        <SvgMetalSvg v-if="['metal'].includes(type)" :type="item.icon" />
                        <SvgShapeSvg v-if="['shape'].includes(type)" :type="item.icon" />
                        {{ item.label }}
                        
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ClickOutsideDirective as vClickOutside } from '@/directives/ClickOutsideDirective';

const { $country } = useNuxtApp();
const localePath = useLocalePath();
const isOpen = ref(false)
const props = defineProps ({
    type:String,
    label:String,
    option:Object,
    validation: String
})

const emit = defineEmits(['toggleOption'])

const currentActive = computed(() => {
    return props.option.find((item) => item.selected === 1)
})
// console.log(currentActive);
const addActive = (value) => {
    // console.log(value, 'sdghsjkd')
    props.option.filter((item) => {
        if(item.value === value) {
            item.selected = 1
            // , console.log(item.value, 'inside loop')
        }else {
            item.selected = 0
        }
        // console.log(item, 'sdghsjkd')
    })

    isOpen.value = false

    emit('toggleOption',props.type)
    // console.log(props.type, 'inend');
}

</script>

<style scoped>
::-webkit-scrollbar {
    width: 2px;
    height: 3px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #f5f5f5; 
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #c4c4c4; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #c4c4c4; 
}

.drop_custom ul{
    max-height: 180px;
    overflow: auto;
    border-radius: 4px;
}
.drop_custom .selected_label svg.svg-head {
    height: 13px;
}
.label_name{
    font-size: 16px;
    font-weight: 600;
    text-transform: capitalize;
    display: flex;
    align-items: center;
}


.svg-metal {
    height: 32px;
    width: 36px;
}
svg.svg-shape {
    height: 28px;
    width: 37px;
}
span.extra{
    float: right;
}
ul li.active, ul li:hover {
    background: rgba(204,204,204,0.36863);
}
/* ul li.disabled {
    pointer-events: none;
    opacity: 0.5;
} */
.selected_label.error {
    border: 1px solid red;
}

.drop_custom .selected_label.focused {
    border-color: var(--green);
    box-shadow: 0 0 0 0.2rem rgb(112 192 153 / 25%);
}

.drop_custom .selected_label_mod {
    border: none !important;
}

/* .number_row .input-group-text {
    font-size: 16px;
    padding: 0 7px;
    background: #fff;
} */

.drop_custom ul li {
    list-style: none;
    padding: 1.5% 16px;
    font-size: 14px;
    cursor: pointer;
    font-weight: 500;
    text-transform: capitalize;
}

.drop_custom ul li.selected {
    background: #cccccc5e;
}

/* .drop_custom ul li img {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-right: 4%;
} */

.drop_block {
    position: relative;
}

.drop_custom ul {
    border: 1px solid #ccc;
    padding: 2% 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background: #fff;
    z-index: 9;
}



.drop_custom .selected_label label {
    text-transform: capitalize;
    margin-bottom: 0;
    color: #212529;
    width: 100%;
    display: flex;
    font-weight: 400;
    min-width: 95px;
}

select option {
    font-family: 'Lato';
    font-size: 15px;
}

.drop_custom .selected_label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 1.5;
    color: #000;
    vertical-align: middle;
    border: 1px solid #ced4da;
    padding: 0 16px;
    font-size: 14px;
    cursor: pointer;
    height: 44px;
    border-radius: 4px;
    margin: 4% 0 0;
}

.selected_label.invalid {
    border: 1px solid #ff0000;
}

/* .drop_custom .selected_label:focus {
    border-color: #668b84;
    border-color: var(--green);
    box-shadow: 0 0 0 0.2rem rgb(112 192 153 / 25%);
} */




@media(max-width: 1050px){
    .drop_custom .selected_label label{
        min-width: 75px;
    }
}

@media(max-width: 768px){
    .label_name {
        font-size: 14px;
    }
    .selected_label label {
        font-size: 14px;
    }

    .drop_custom .selected_label{
        margin: 2% 0 0;

    }
    
} 
</style>